module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component",
    attrs: {
      "id": "app",
      "data-site": _vm.currentRoute
    }
  }, [_c('AddonBookingHeader'), _vm._v(" "), _c('Cart'), _vm._v(" "), _c('router-view'), _vm._v(" "), (_vm.currentModal) ? _c(_vm.currentModal.component, {
    tag: "div",
    attrs: {
      "params": _vm.getCurrentModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getCurrentTimeoutModal) ? _c(_vm.currentTimeoutModal.component, {
    tag: "div",
    attrs: {
      "params": _vm.getCurrentTimeoutModal
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dropdown-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "cart-background"
  }), _vm._v(" "), (_vm.$store.state.isDebugging) ? _c('div', {
    staticClass: "debugging",
    on: {
      "click": function($event) {
        _vm.$store.state.isDebugging = false
      }
    }
  }, [_vm._v("\n    API: " + _vm._s(_vm.apiUrl) + "        \n    "), _vm._l((_vm.languages), function(lang) {
    return _c('button', {
      staticClass: "small",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.setLanguage(lang)
        }
      }
    }, [_vm._v(_vm._s(lang))])
  })], 2) : _vm._e(), _vm._v(" "), (!_vm.$store.state.isOnSite) ? _c('WebFooter') : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.env !== 'production' && _vm.SITE_CONFIG.is_production) ? _c('div', {
    staticClass: "production-mode-alert"
  }, [_vm._v("\n    ⚠️ Produktionsläge ⚠️\n  ")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25441132"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 937
// module chunks = 0